import { CommonModule } from '@angular/common';
import { afterNextRender, Component, inject, signal, viewChild } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, MbsPopupType, ModalComponent, ModalFooterDirective, ModalService } from 'mbs-ui-kit';
import { PermissionsEnum } from 'mbs-ui-shared@models';
import Computer from 'mbs-ui-shared@models/Computer';
import { noop } from 'rxjs';
import { ComputerAuthorizationModalComponent } from '../computer-authorization/computer-authorization-modal.component';

@UntilDestroy()
@Component({
  selector: 'remote-connection-auth-required-modal-component',
  templateUrl: './remote-connection-auth-required-modal.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonComponent,
    NgbTooltipModule,
    AlertComponent,
    I18NextPipe,
    ModalComponent,
    ModalFooterDirective
  ]
})
export class RemoteConnectionAuthRequiredModalComponent {
  private modalService = inject(ModalService);
  private i18nPipe = inject(I18NextPipe);

  public baseModal = viewChild(ModalComponent);

  computer = signal<Computer>(null);
  mbsPopupType = MbsPopupType;

  constructor() {
    afterNextRender(() => {
      if (this.baseModal().data) {
        this.computer.set(this.baseModal().data.computer);
      }
    });
  }

  handleAuthorize() {
    const modal = this.modalService.openRef(ComputerAuthorizationModalComponent, {
      permissions: [PermissionsEnum.Users, PermissionsEnum.ManageCompanies],
      missingPermissionActionName: this.i18nPipe.transform('shared:computers.modals.computerAuthorizationActionName')
    });

    this.baseModal().close();
    if (!modal) return modal;

    (modal.componentInstance as ComputerAuthorizationModalComponent).computers = [this.computer()];
    modal.result.catch(noop);
    return modal;
  }
}
